"use strict";

var _classCallCheck = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var specification_1 = require("../specification");

var AttrBuilder =
/*#__PURE__*/
function () {
  function AttrBuilder() {
    _classCallCheck(this, AttrBuilder);
  }

  _createClass(AttrBuilder, null, [{
    key: "attr",
    value: function attr(name, type) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var r = {};
      r[name] = Object.assign({
        name: name,
        type: type
      }, options);
      return r;
    }
  }, {
    key: "number",
    value: function number(name) {
      var solvable = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      if (solvable) {
        return this.attr(name, specification_1.AttributeType.Number, options);
      } else {
        return this.attr(name, specification_1.AttributeType.Number, Object.assign({
          solverExclude: true
        }, options));
      }
    }
  }, {
    key: "color",
    value: function color(name) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this.attr(name, specification_1.AttributeType.Color, Object.assign({
        solverExclude: true
      }, options));
    }
  }, {
    key: "boolean",
    value: function boolean(name) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this.attr(name, specification_1.AttributeType.Boolean, Object.assign({
        solverExclude: true
      }, options));
    }
  }, {
    key: "enum",
    value: function _enum(name) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this.attr(name, specification_1.AttributeType.Enum, Object.assign({
        solverExclude: true
      }, options));
    }
  }, {
    key: "line",
    value: function line() {
      return Object.assign({}, this.number("x1"), this.number("y1"), this.number("x2"), this.number("y2"));
    }
  }, {
    key: "point",
    value: function point() {
      return Object.assign({}, this.number("x"), this.number("y"));
    }
  }, {
    key: "center",
    value: function center() {
      return Object.assign({}, this.number("cx"), this.number("cy"));
    }
  }, {
    key: "size",
    value: function size() {
      return Object.assign({}, this.number("width", true, {
        defaultRange: [0, 200]
      }), this.number("height", true, {
        defaultRange: [0, 200]
      }));
    }
  }, {
    key: "dXdY",
    value: function dXdY() {
      return Object.assign({}, this.number("dx", true, {
        defaultRange: [30, 100]
      }), this.number("dy", true, {
        defaultRange: [30, 100]
      }));
    }
  }, {
    key: "opacity",
    value: function opacity() {
      return this.number("opacity", false, {
        defaultRange: [0, 1],
        defaultValue: 1
      });
    }
  }, {
    key: "visible",
    value: function visible() {
      return this.boolean("visible", {
        defaultValue: true
      });
    }
  }, {
    key: "image",
    value: function image() {
      return this.attr("image", specification_1.AttributeType.Image, {
        solverExclude: true,
        defaultValue: null
      });
    }
  }, {
    key: "style",
    value: function style() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var r = Object.assign({}, this.color("stroke", {
        defaultValue: null
      }), this.number("strokeWidth", false, {
        defaultRange: [0, 5],
        defaultValue: 1
      }), this.opacity(), this.visible());

      if (options.fill) {
        r.fill = this.color("fill", {
          defaultValue: null
        }).fill;
      }

      return r;
    }
  }]);

  return AttrBuilder;
}();

exports.AttrBuilder = AttrBuilder;